import { boolean, object, string } from 'yup';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_70_LENGTH } from '@constants/validationMessages';

export const schema = object({
	name: string()
		.trim()
		.max(MAX_70_LENGTH, getMaxLengthErrMsg('Preset Name', MAX_70_LENGTH))
		.required(validationErrMessages.presetName),
	isShared: boolean()
		.nullable(),
});
